import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeRecordIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 1.89999C6.42999 1.89999 1.89999 6.42999 1.89999 12C1.89999 17.57 6.42999 22.1 12 22.1C17.57 22.1 22.1 17.57 22.1 12C22.1 6.42999 17.57 1.89999 12 1.89999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeRecordIcon.displayName = 'TimeRecordIcon';
